/** Shared password strength rules for create / change / reset flows. */

export const PASSWORD_POLICY_HINT =
  "At least 8 characters with uppercase, lowercase, a digit, and a special character.";

/**
 * @param {string} password
 * @returns {string|null} Error message, or null if valid.
 */
export function validatePasswordStrength(password) {
  const value = password == null ? "" : String(password);
  if (value.length < 8) {
    return "Password must be at least 8 characters.";
  }
  if (!/[A-Z]/.test(value)) {
    return "Password must include at least one uppercase letter.";
  }
  if (!/[a-z]/.test(value)) {
    return "Password must include at least one lowercase letter.";
  }
  if (!/[0-9]/.test(value)) {
    return "Password must include at least one digit.";
  }
  if (!/[^A-Za-z0-9]/.test(value)) {
    return "Password must include at least one special character.";
  }
  return null;
}
